

















import "@/components/icons";
import {
  defineComponent,
  PropType,
  reactive,
  toRefs
} from "@vue/composition-api";
import { Data, Props } from "./types";

export default defineComponent({
  name: "TableHeadHeader",
  props: {
    sortable: {
      type: Boolean as PropType<Props["sortable"]>,
      default: false
    },
    initialOrder: {
      type: String as PropType<Props["initialOrder"]>,
      default: "DESC"
    }
  },
  emits: ["changeOrder"],
  setup(props, { emit }) {
    const state = reactive<Data>({
      order: props.initialOrder
    });

    const handleClick = () => {
      state.order = state.order === "DESC" ? "ASC" : "DESC";
      emit("changeOrder", state.order);
    };

    return {
      ...toRefs(state),
      handleClick
    };
  }
});
